export const bg = "var(--seed-color-manner-temp-l3-bg)";
export const text = "var(--seed-color-manner-temp-l3-text)";